import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Combobox, DetailComponent, NotificationService } from 'pmv-common';
import { PMVAuthenticationService } from 'pmv-common';

import { PessoaService } from '../../../services/pessoa.service';
import { Inscricao } from '../../../models/inscricao-model';
import { RouteNavigationService } from '../../../services/api/route-navigation.service';
import { Pessoa } from '../../../models/pessoa.model';
import { Lista } from '../../../models/lista.model';
import { ListaService } from '../../../services/lista.service';
import { ListaEnum } from '../../../models/enum/lista';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { EnderecoService } from '../../../services/endereco.service';

@Component({
    selector: 'pmv-dados-adicionais',
    templateUrl: './dados-adicionais.component.html',
    styleUrls: ['./dados-adicionais.component.scss']
})

export class DadosAdicionaisComponent extends DetailComponent implements OnInit {
    subtitle: string;
    loading: boolean = true;
    confirmarVerdadeInfo: boolean = false;
    habilitarCidadeTituloForm: boolean = false;
    editalAnoPss: string;
    inscricao: Inscricao;
    pessoaForm: Pessoa = new Pessoa();
    pessoaBD: Pessoa = new Pessoa();
    ufOptions: Combobox[];

    grupoSanguineoOptions: Combobox[];
    fatorRHOptions: Combobox[];
    nacionalidadeOptions: Combobox[];
    paisDeNascimentoOptions: Combobox[];
    tipoDeficienciaOptions: Combobox[];
    primeiroEmpregoOptions: Combobox[];
    cidadeTituloOptions: Combobox[];
    possuiPrevidenciaComplementarOptions: Combobox[];
    cnhCategoriafOptions: Combobox[];
    reservistaCategoriaOptions: Combobox[];
    reservistaForcaOptions: Combobox[];

    constructor(
        private routeDataService: RouteNavigationService,
        private readonly notificationService: NotificationService,
        private route: ActivatedRoute,
        private pessoaService: PessoaService,
        private enderecoService: EnderecoService,
        private listaService: ListaService,
        private authenticationService: PMVAuthenticationService
    ) { super(route); }

    handleValidSubmission(form: NgForm): void {
        forkJoin(
            this.pessoaService.UpdateDadosAdicionais(this.pessoaForm, this.inscricao.concurso, this.inscricao.nrInscricao),
        ).subscribe(res => {
            if (res == null) {
                this.notificationService.notifyError('Erro desconhecido ao tentar salvar dados adicionais.');
            }
            else {
                const retorno = res[0];
                if (retorno.errosCompilados == null) {
                    this.notificationService.notifySuccess("Dados Adicionais salvos com sucesso.");
                    this.routeDataService.toCandidatoConvocado();
                } else {
                    this.notificationService.notifyError(res[0].errosCompilados);
                }
            }
        }, erro => {
            this.notificationService.notifyError(erro);
        });
    }

    ngOnInit(): void {
        this.loading = true;
        const canActivate = this.authenticationService.isUserLoggedIn();
        if (canActivate) {
        } else {
            this.authenticationService.redirectToLoginPage();
            return;
        }

        this.subtitle = 'Preencha todos os dados solicitados para continuar com o processo de admissão.';
        const cpfCurrent = this.authenticationService.getIdLoged();
        this.getCarregarDadosInscricao(cpfCurrent.toString());
    }

    getCarregarDadosInscricao(cpf: string) {
        this.inscricao = this.routeDataService.getDataDadosCandidatoConvocado();
        if (!this.inscricao) {
            throw 'Error ao tentar recuperar dados da inscrição.';
        }

        this.editalAnoPss = 'Edital ' + this.inscricao.anoNumeroEdital + ' - ' + this.inscricao.cargoFuncao;
        this.listaService.PostByParam([ListaEnum.GRUPOSANGUINEO, ListaEnum.FATORRH, ListaEnum.NACIONALIDADE
            , ListaEnum.TIPODEFICIENCIAFISICA, ListaEnum.CNHCATEGORIA, ListaEnum.RESERVISTACATEGORIA, ListaEnum.RESERVISTAFORCA
        ]).subscribe(
            response => {
                this.carregarListas(response);
                this.carregarDadosPessoa(cpf);
            }, error => {
                throw error;
            });
    }

    carregarListas(listas: Lista[]) {
        forkJoin(
            this.enderecoService.GetEstadoCombobox(),
        ).subscribe(resUf => {
            const listaUf = resUf[0];
            this.ufOptions = listaUf;
        }, error => {
            throw error;
        });

        this.grupoSanguineoOptions = this.filtratLista(listas, ListaEnum.GRUPOSANGUINEO);
        this.fatorRHOptions = this.filtratLista(listas, ListaEnum.FATORRH);
        this.nacionalidadeOptions = this.filtratLista(listas, ListaEnum.NACIONALIDADE);

        let listaDef = this.filtratLista(listas, ListaEnum.TIPODEFICIENCIAFISICA);
        listaDef.unshift({ id: 0, descricao: "NENHUMA" });
        this.tipoDeficienciaOptions = listaDef;

        this.cnhCategoriafOptions = this.filtratLista(listas, ListaEnum.CNHCATEGORIA);
        this.reservistaCategoriaOptions = this.filtratLista(listas, ListaEnum.RESERVISTACATEGORIA);
        this.reservistaForcaOptions = this.filtratLista(listas, ListaEnum.RESERVISTAFORCA);

        this.listaService.GetPaisesHeSocial().subscribe(
            response => {
                this.paisDeNascimentoOptions = this.filtratLista(response, 0);
            });

        this.primeiroEmpregoOptions = this.listaComboSimNao();
        this.possuiPrevidenciaComplementarOptions = this.listaComboSimNao();
    }

    carregarDadosPessoa(cpf: string) {
        forkJoin(
            this.pessoaService.GetPessoaByCpf(cpf)
        ).subscribe(res => {
            this.pessoaBD = res[0];
          
            this.pessoaBD.documentos.emissaoTitulo = this.tratarData(this.pessoaBD.documentos.emissaoTitulo);
            this.pessoaBD.documentos.ctpsEmissao = this.tratarData(this.pessoaBD.documentos.ctpsEmissao);
            this.pessoaBD.documentos.pisInscricao = this.tratarData(this.pessoaBD.documentos.pisInscricao);
            this.pessoaBD.documentos.cnhEmissao = this.tratarData(this.pessoaBD.documentos.cnhEmissao);
            this.pessoaBD.documentos.cnhValidade = this.tratarData(this.pessoaBD.documentos.cnhValidade);
            this.pessoaBD.documentos.cnhPrimeiraEmissao = this.tratarData(this.pessoaBD.documentos.cnhPrimeiraEmissao);
            this.pessoaBD.documentos.reservistaEmissao = this.tratarData(this.pessoaBD.documentos.reservistaEmissao);
            this.pessoaBD.documentos.conselhoRegionalEmissao = this.tratarData(this.pessoaBD.documentos.conselhoRegionalEmissao);
            this.pessoaBD.documentos.conselhoRegionalValidade = this.tratarData(this.pessoaBD.documentos.conselhoRegionalValidade);

            this.pessoaForm = new Pessoa();
            this.pessoaForm.CarregarDadosPessoa(this.pessoaBD);
            this.loading = false;
            this.CarregarCidadesTitulo();
        }, error => {
            throw error;
        });

    }

    tratarData(data: Date): Date {
        if (data !== null && data !== undefined) {
            return new Date(data);
        }
        return null;
    }



    listaComboSimNao(): Combobox<number>[] {
        const pe = [];
        pe.push(this.gerarCombobox(1, 'SIM'));
        pe.push(this.gerarCombobox(0, 'NÃO'));
        return pe;
    }

    gerarCombobox(numero: number, texto: string): Combobox<number> {
        const combo = new Combobox();
        combo.descricao = texto;
        combo.id = numero;
        return combo;
    }

    filtratLista(listas: Lista[], codigoLista: number): Combobox[] {
        let filtrada = [];
        listas.forEach(element => {
            if (element.t01070_I_CDLISTA == codigoLista) {
                filtrada.push(this.gerarCombobox(element.t01071_I_CDITEM, element.t01071_S_VALORSTR));
            }
        });
        return filtrada;
    }

    voltar(): void {
        this.routeDataService.toCandidatoConvocado();
    }

    delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    CarregarCidadesTitulo(): void {
        let uf = '';
        this.delay(400);
        if (this.ufOptions.length > 0 && this.pessoaForm.documentos.codigoUfTitulo !== null) {
            uf = this.ufOptions.find(p => p.id === this.pessoaForm.documentos.codigoUfTitulo).descricao;
            forkJoin(
                this.enderecoService.GetCidadesByUfCombobox(uf),
            ).subscribe(res => {
                this.cidadeTituloOptions = res[0];
                this.HabilitarEdicaoCidadetitulo();
            }, error => {
                throw error;
            });
        } else {
            this.cidadeTituloOptions = [];
        }
    }

    HabilitarEdicaoCidadetitulo(): void {
        this.habilitarCidadeTituloForm = (this.pessoaForm.documentos.codigoUfTitulo !== 0 && this.pessoaForm.documentos.codigoCidadeTitulo! == 0);
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/candidato-convocado/dadosAdicionais/dados-adicionais.component.ts